import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';

export type MessageListBoxListItemProps = ComponentProps<'li'>;

export const MessageListBoxListItem: FunctionComponent<MessageListBoxListItemProps> =
  React.memo((props) => {
    const { children, ...remainingProps } = prepareProps({ props });

    return <li {...remainingProps}>{children}</li>;
  });
